export enum TextDecoration {
  none,
  underline,
  overline,
  lineThrough,
}
